import { Modal } from 'antd';
import { ColumnsType } from 'antd/lib/table/interface';
import { useCallback, useEffect, useMemo } from 'react';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import { ITripHistory, ITripPlanStore } from '../../model/TripPlanModel';
import { useTripPlanStore } from '../../stores/TripPlanStore';
import { DD_MM_YYYY_H_MM } from '../../utils/app-common';
import { convertDateFromMillis } from '../../utils/luxon';
import LoadingComponent from '../CommonComponent/LoadingComponent';
import TableComponent from '../CommonComponent/TableComponent';

type ITripHistoryComponent = {
    isOpen: boolean,
    closeModal: () => void,
    tripCode: string | undefined,
    tripId: number | undefined

}
export const TripHistoryComponent = ({ isOpen, closeModal, tripCode, tripId }: ITripHistoryComponent) => {
    const { promiseInProgress } = usePromiseTracker({ area: 'trip-history-area' })

    const GetTripHistoryAction = useTripPlanStore((state: ITripPlanStore) => state?.GetTripHistoryAction)
    const tripHistoryList: ITripHistory[] = useTripPlanStore((state: ITripPlanStore) => state?.tripHistoryList)

    const getTrackingData = useCallback(() => {
        if (tripId) {
            trackPromise(GetTripHistoryAction(tripId), 'trip-history-area');
        }
    }, [GetTripHistoryAction, tripId])

    useEffect(() => {
        getTrackingData();
    }, [getTrackingData])

    const trackingHistoryColumn: ColumnsType<ITripHistory> = useMemo(() => [
        {
            title: 'Trip Plan Number',
            dataIndex: 'tripCode',
            key: 'tripCode',
            width: 50,
            fixed: 'left',
        },
        {
            title: 'Station',
            dataIndex: 'scanStationName',
            key: 'scanStationName',
            width: 40,
            fixed: 'left',
        },
        {
            title: 'Scan Type',
            dataIndex: 'scanType',
            key: 'scanType',
            width: 80,
        },
        {
            title: 'Scanned By',
            dataIndex: 'scannedByName',
            key: 'scannedByName',
            width: 80,
        },
        {
            title: 'Scan Date',
            dataIndex: 'scannedDate',
            key: 'scannedDate',
            width: 80,
            render: (_, record) => convertDateFromMillis(record?.scannedDate, DD_MM_YYYY_H_MM)
        },
        {
            title: 'Remarks',
            dataIndex: 'remarks',
            key: 'remarks',
            width: 150,
        },
    ], [])

    const onResetClicked = useCallback(() => {
        getTrackingData();
    }, [getTrackingData])

    return (
        <>
            {promiseInProgress && <LoadingComponent />}
            <Modal maskClosable={false} open={isOpen} onOk={closeModal} title={`${tripCode}`} centered onCancel={closeModal} 
            width={1200} cancelButtonProps={{
                style: { display: 'none' }
            }}>
                <TableComponent
                    scroll={{ x: 0, y: 0 }}
                    columns={trackingHistoryColumn}
                    isLoading={promiseInProgress}
                    data={tripHistoryList}
                    onRefreshHandle={onResetClicked} />
            </Modal>
        </>
    )
}
